const colors = {
    primary: '#FF3200',
    primaryHover: '#DF2C00',
    primaryPressed: '#C12600',
    primaryContrast: '#fff',
    primaryVisited: '#FF3200',

    accent: '#27272e',
    accentContrast: '#fff',
    accentContrastSecondary: 'rgba(255, 255, 255, 0.6)',
    accentDarken: 'rgba(0, 0, 0, .2)',
    accentControlBg: 'rgba(0, 0, 0, .1)',
    accentBorder: 'rgba(255, 255, 255, 0.2)',
    accentBorderHover: 'rgba(255, 255, 255, 0.3)',

    error: '#e14d4d',
    errorHover: '#d44c4d',
    errorPressed: '#d44c4d',
    errorContrast: '#fff',

    warning: '#FF3200',
    warningHover: '#DF2C00',
    warningPressed: '#C12600',
    warningContrast: '#fff',

    success: '#53BA95',
    successHover: '#5dae5e',
    successPressed: '#5dae5e',
    successContrast: '#fff',
} as const;

export default { colors };
